import { isNotInRange } from "../../utils/customFunctions";

export const validateContentTypeData = async ({
	titles,
	icon,
	iconAssetId = null,
	hasInteractiveVideos,
	interactiveVideoTitles,
}) => {
	const errors = {};

	if (!titles?.en && !titles?.ar) {
		errors.titles = {
			en: "validationErrors.required.oneIsRequired",
			ar: "validationErrors.required.oneIsRequired",
		};
	}

	if (titles?.ar && isNotInRange({ min: 3, max: 50, str: titles.ar })) {
		errors.titles = {
			ar: {
				message: "validationErrors.minMax.titles",
				args: { min: 3, max: 50 },
			},
		};
	}

	if (titles?.en && isNotInRange({ min: 3, max: 50, str: titles.en })) {
		errors.titles = {
			en: {
				message: "validationErrors.minMax.titles",
				args: { min: 3, max: 50 },
			},
		};
	}

	if (!icon && !iconAssetId) errors.icon = "Icon is required!";

	if (hasInteractiveVideos) {
		if (!interactiveVideoTitles || (!interactiveVideoTitles.en && !interactiveVideoTitles.ar)) {
			errors.interactiveVideoTitles = {
				en: "validationErrors.required.oneIsRequired",
				ar: "validationErrors.required.oneIsRequired",
			};
		} else {
			if (interactiveVideoTitles?.en &&
				isNotInRange({ min: 3, max: 100, str: interactiveVideoTitles.en })) {
				errors.interactiveVideoTitles = {
					en: {
						message: "validationErrors.minMax.interactiveVideoTitles",
						args: { min: 3, max: 100 },
					},
				};
			}
			if (interactiveVideoTitles?.ar &&
				isNotInRange({ min: 3, max: 100, str: interactiveVideoTitles.ar })) {
				errors.interactiveVideoTitles = {
					ar: {
						message: "validationErrors.minMax.interactiveVideoTitles",
						args: { min: 3, max: 100 },
					},
				};
			}
		}
	}

	return errors;
};
